import type { BuyerQualificationVerdictDto } from "../../../../../autogen/bff-api";

/**
 * Returns "Decided by <name> · <date>" when the verdict records a decider,
 * otherwise just the formatted date. Used wherever a verdict timestamp is shown.
 */
export const formatDecidedBy = (
  verdict: Pick<BuyerQualificationVerdictDto, "decidedByName" | "decidedAt">,
  displayDateWithTime: (iso: string) => string,
  t: (key: string) => string,
): string =>
  verdict.decidedByName
    ? `${t("Decided by")} ${verdict.decidedByName} · ${displayDateWithTime(verdict.decidedAt)}`
    : displayDateWithTime(verdict.decidedAt);
